import VueRouter from "vue-router";
import Vue from "vue";
import Subheader from "../views/Subheader.vue";
import Media from "../views/Media.vue";
import Careers from "../views/Careers.vue";
import EditPressRelease from "../views/EditPressRelease.vue";
import JobPostingPage from "../views/JobPostingPage.vue";
import EditJobPosting from "../views/EditJobPosting.vue";
import VideosPage from "../views/VideosPage.vue";
import PressReleasePage from "../views/PressReleasePage.vue";
import UploadNewFile from "../views/UploadNewFile.vue";
import UploadNewVideo from "../views/UploadNewVideo.vue";
import EditVideo from "../views/EditVideo.vue";
import UploadNewArticle from "../views/UploadNewArticle.vue";
import ArticlesPage from "../views/ArticlesPage.vue";
import EditArticle from "../views/EditArticle.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Subheader",
    component: Subheader,
  },

  {
    path: "/news",
    name: "Media",
    component: Media,
  },

  {
    path: "/news/edit/:id",
    name: "EditPressRelease",
    component: EditPressRelease,
    props: true,
  },

  {
    path: "/news/details/:id",
    name: "PressReleasePage",
    component: PressReleasePage,
    props: true,
  },

  {
    path: "/careers",
    name: "Careers",
    component: Careers,
  },

  {
    path: "/careers/details/:id",
    name: "JobPostingPage",
    component: JobPostingPage,
    props: true,
  },

  {
    path: "/careers/edit/:id",
    name: "EditJobPosting",
    component: EditJobPosting,
    props: true,
  },

  {
    path: "/videos/:id",
    name: "VideosPage",
    component: VideosPage,
    props: true,
  },

  {
    path: "/upload/:path",
    name: "UploadNewFile",
    component: UploadNewFile,
    props: true,
  },

  {
    path: "/video/upload",
    name: "UploadNewVideo",
    component: UploadNewVideo,
  },

  {
    path: "/article/upload",
    name: "UploadNewArticle",
    component: UploadNewArticle,
  },

  {
    path: "/video/:id",
    name: "EditVideo",
    component: EditVideo,
    props: true,
  },

  {
    path: "/articles/details/:id",
    name: "ArticlesPage",
    component: ArticlesPage,
    props: true,
  },

  {
    path: "/article/edit/:id",
    name: "EditArticle",
    component: EditArticle,
    props: true,
  },
];

const router = new VueRouter({
  routes,

  scrollBehavior(to) {
    if (to.params.location) {
      document.getElementById(to.params.location).scrollIntoView({
        behavior: "smooth",
      });
    }
  },
});

export default router;
